var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-article"},[_c('article-form',{attrs:{"action":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }